import { washLanguageData, washImg, washProductFour, washListItem, washProductThree, washProTwoBtn,washArabic } from '@/utils/wash.js'
import { findRecursive } from '@/mm/utils.js'
import { getNodeByFlag } from '@/components/common/controlBar/controlBarDialog/metaComponent/utils.js'

const washData = (node) => {
  try {
    switch (node._type) {
      case 'home_product_one':
        washImg(node)
        washListItem(node)
      case 'home_product_two':
        washLanguageData(node, 'product-cate-list-btn')
        washImg(node)
        washListItem(node)
        washProTwoBtn(node)
        break
      case 'home_product_three':
        const ProNode = findRecursive(
          node.list,
          (item) => item._type === 'button_text_icon_9',
          'list'
        )
        const imgNode = findRecursive(
          node.list,
          (item) => item.componentName === 'image_image1',
          'list'
        )
        const cardNode = findRecursive(node.list, (item) => item.componentName === 'card', 'list')
        washLanguageData(node, 'product-cate-list-btn')
        if (ProNode) {
          ProNode.actions = [
            {
              name: 'design',
              groupLayout: 'topBottom',
              config: {
                文字设计: [
                  'self_textInput',
                  'self_fontFamily',
                  'self_fontSize',
                  'self_color',
                  'self_textStyle',
                  'self_textAlign'
                ],
                按钮设计: [
                  'self_background',
                  'self_icon',
                  'icon_fontSize',
                  'self_border',
                  'self_margin',
                  'self_padding',
                  'self_transverseMargin2',
                  'self_width',
                  'self_borderRadius',
                  'self_shadow'
                ]
              }
            },
            'hover',
            'translate'
          ]
        }
        if (imgNode) {
          imgNode.actions = [
            {
              name: 'design',
              groupLayout: 'topBottom',
              config: {
                分组: [
                  'self_margin',
                  'self_padding',
                  'rediu_padding',
                  'img_border',
                  'self_shadow',
                  'self_borderRadius'
                ]
              }
            },
            'hover'
          ]
        }
        if (cardNode) {
          cardNode.actions = [
            {
              name: 'design',
              groupLayout: 'topBottom',
              config: {
                分组: ['2', '3', '4', 'self_borderRadius', 'self_shadow']
              }
            },
            'hover'
          ]
        }
        washProductThree(node)
        break
      case 'home_product_four':
        washProductFour(node)
        break
    }
    washArabic(node)
  } catch (err) {
    console.log('err--', err)
  }
}
export { washData }
